import API from "../../Api";
import {
  CNPDataOrder,
  FirstDataOrder,
  offlineOrderData,
  RazorPayTransferOrder,
  StripeInitiatePaymentPayload,
} from "./PaymentModels";
import { encryptJson } from "../../utils/react-ec-utils";
import axios from "axios";
import { CARD_TOKENIZATION_URL } from "../../constants";

export function razorPayTransferOrderAPI(details: RazorPayTransferOrder) {
  const data = encryptJson(details);
  return API({
    method: "post",
    url: "/api/customers/payment/authorize",
    data: { data: data },
    //params:{data}
  });
}
export function firstDataTransferOrderAPI(details: FirstDataOrder) {
  const data = encryptJson(details);
  return API({
    method: "post",
    url: "/api/customers/payment/authorize-payment",
    params: { data },
  });
}

export function catpurePaymentAPI(details: any) {
  const data = encryptJson(details);
  return API({
    method: "post",
    url: "/api/customers/payment/collect-payment",
    params: { data },
  });
}

export function stripeInitatePaymentAPI(details: StripeInitiatePaymentPayload) {
  return API({
    method: "post",
    url: "/payment/initiatePayment",
    data: details,
  });
}

export function offlinePaymentAPI(details: offlineOrderData) {
  const data = encryptJson(details);
  return API({
    method: "post",
    url: "/api/customers/payment/initiate-offline-payment",
    params: { data },
  });
}

export function initiatetCNPPayemnetAPI(details: CNPDataOrder) {
  const data = encryptJson(details);
  return API({
    method: "post",
    url: "/api/customers/payment/start-transaction",
    data: {
      data,
    },
  });
}

export function tokenizeCardDetail(cardData: any) {
  return axios.post(CARD_TOKENIZATION_URL, cardData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: "68bef434f32547a5840ad7048b477a67",
    },
  });
}

export function saveCardDetail(cardData: any) {
  // const data = encryptJson(cardData);
  return API({
    method: "post",
    url: "/api/customers/payment/add-cards",
    data: cardData,
  });
}

export function getCardDetails(customerId: string) {
  // const data = encryptJson(cardData);
  return API({
    method: "get",
    url: "/api/customers/payment/fetch-cards",
    params: { customerId },
  });
}

export function deleteCardDetails(cardId: string) {
  // const data = encryptJson(cardData);
  return API({
    method: "delete",
    url: "/api/customers/payment/remove-cards",
    params: { cardId },
  });
}
